import React from 'react';
import { PollyEnv } from '../../types';
import { redirectToPollyLogin } from '../../utils/auth';

export default function SessionExpiredModal({ env }: { env: PollyEnv }) {
  return (
    <div className="app-unauthorized">
      <div className="app-unauthorized__card">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#8E42EE" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
        <h2 className="app-unauthorized__title">Session expired</h2>
        <p className="app-unauthorized__desc">
          Your session has expired. Please log in again to continue.
        </p>
        <button
          className="app-unauthorized__btn"
          onClick={() => redirectToPollyLogin(env)}
        >
          Log in again
        </button>
      </div>
    </div>
  );
}
